import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_LOCATION_TYPE_CATEGORY_MUTATION } from '../graphql/mutations'
import { DELETE_LOCATION_TYPE_CATEGORY } from '../redux/action-types'

const useDeleteLocationTypeCategoryMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.locationTypes.locationTypesAndLocationTypeCategories,
  )

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_LOCATION_TYPE_CATEGORY_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_LOCATION_TYPE_CATEGORY,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteLocationTypeCategoryMutation
